import { RootState } from 'store';

export const selectAppointmentRepeatFrequencies = ({ appointments }: RootState) => appointments.repeatFrequencies.rows;
